import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import type { TListParticipationsRequest, TListParticipationsResponse } from '/src/lib/types';

export class ParticipationService {
  /**
   * List Participations
   * @returns Participation[]
   * @throws ApiError
   */
  public static async query(req?: TListParticipationsRequest): CancelablePromise<TListParticipationsResponse> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/participations',
      query: req,
    });
  }
}
